import { type Column, type RowData } from "@tanstack/react-table";
import { groupByFn } from "~/common/utils/reducers";

type TSide = "left" | "center" | "right";
type TUnit = "px" | "%";
type TSize = {
  value: number;
  unit: TUnit;
};
export const getSize = <T extends RowData>(column: Column<T>): TSize | undefined => {
  const size = column.columnDef.size;
  if (!size) {
    return undefined;
  }
  return {
    value: size,
    unit: size < 1.0 ? "%" : "px",
  } as const;
};
export const getCssSize = (size: TSize): string => {
  if (size.unit === "px") {
    return size.value + "px";
  }
  if (size.unit === "%") {
    return size.value * 100 + "%";
  }
  throw new Error("Not implemented");
};
export const getWidth = (sizes: TSize[]) => {
  const byUnit = groupByFn(sizes, (s) => s.unit);
  const totals = Object.entries(byUnit).map(([unit, sizes]) => {
    const total = sizes.map((s) => s.value).reduce((a, b) => a + b, 0);
    return {
      value: total,
      unit,
    } as TSize;
  });

  if (totals.length > 1) {
    return `calc(${totals.map(getCssSize).join(" + ")})`;
  } else {
    return getCssSize(totals[0]);
  }
};
